import React, { FC, useMemo, useState } from 'react';
import { ProTablePlus } from '@bedrock/eed-react';
import { FormModule } from '@purchase/supplier';

export interface QccBangDanTableProps {
  list: any[];
}

const uniq = (arr: any[], key: string) => {
  const seen = new Set<string>();
  arr.forEach((i) => {
    const v = i?.[key];
    if (v) seen.add(v);
  });
  return Array.from(seen).map((v) => ({ name: v, value: v }));
};

export const QccBangDanTable: FC<QccBangDanTableProps> = ({ list }) => {
  const [filter, setFilter] = useState<{
    type?: string;
    source?: string;
    ranking?: string;
  }>({});

  const typeOptions = useMemo(() => uniq(list, 'type'), [list]);
  const sourceOptions = useMemo(() => uniq(list, 'source'), [list]);
  const rankingOptions = useMemo(() => uniq(list, 'ranking'), [list]);

  const filtered = useMemo(
    () =>
      list.filter(
        (i) =>
          (!filter.type || i.type === filter.type) &&
          (!filter.source || i.source === filter.source) &&
          (!filter.ranking || i.ranking === filter.ranking)
      ),
    [list, filter]
  );

  const columns = useMemo(
    () => [
      {
        title: '#',
        dataIndex: '#',
        width: 50,
        render: (_: unknown, __: unknown, index: number) => index + 1,
      },
      {
        title: '榜单名称',
        dataIndex: 'title',
        render: (v?: string) => v || '-',
      },
      {
        title: '榜单类型',
        dataIndex: 'type',
        filterRender: {
          name: 'select',
          props: { options: typeOptions, multiple: false },
        },
        render: (v?: string) => v || '-',
      },
      {
        title: '来源',
        dataIndex: 'source',
        filterRender: {
          name: 'select',
          props: { options: sourceOptions, multiple: false },
        },
        render: (v?: string) => v || '-',
      },
      {
        title: '榜内位置',
        dataIndex: 'ranking',
        filterRender: {
          name: 'select',
          props: { options: rankingOptions, multiple: false },
        },
        render: (v?: string) => v || '-',
      },
      {
        title: '发布日期',
        dataIndex: 'publishDate',
        width: 110,
        render: (v?: string) => v || '-',
      },
    ],
    [typeOptions, sourceOptions, rankingOptions]
  );

  return (
    <FormModule
      title="上榜榜单"
      titleCount={list.length}
      proCardProps={{ expandable: true, defaultExpanded: list.length > 0 }}
      skipAnchorCollect
    >
      <ProTablePlus
        columns={columns as any}
        data={filtered}
        pagination={false}
        scroll={{ x: true }}
        onFilterChange={
          ((_dataIndex: string, filterValue: Record<string, any>) =>
            setFilter({
              type: filterValue.type ?? '',
              source: filterValue.source ?? '',
              ranking: filterValue.ranking ?? '',
            })) as any
        }
      />
    </FormModule>
  );
};
